import React, { useEffect, useState } from "react";
import { newTabWrapCss,  } from "./NewTab.style";
import { css } from "@emotion/react";
import {ReactComponent as BookBg} from 'src/assets/bookBg.svg';
import {ReactComponent as BookBg2} from 'src/assets/bookBg2.svg';
import {useNavigate, Link} from "react-router-dom";
import {useIsMobile} from "../../../hooks/useIsMobile";
import NewBookMobile from "../../../domain/book/mobile/NewBookMobile";
import {useNewBookList} from "../../../domain/book/hooks/useNewBookList";

const BookWrapper = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1200px;
    /*  height: 40vh;*/
    margin-top : 540px;
    /* background-color: white; */

/*    @media (max-width: 1024px) {
        .firstBg {
            width: 30vw; !* 뷰포트 너비의 30%로 조정 *!
            height: 30vw;
            top: 5vh;
            left: 5vw;
        }

        .secondBg {
            width: 30vw;
            height: 30vw;
            bottom: 5vh;
            right: 5vw;
        }
    }

    @media (max-width: 640px) {
        .firstBg, .secondBg {
            display: none; !* 태블릿 크기부터는 숨기기 *!
        }
    }
    */
    
`;

const BookListWrapper = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;


    .bookCarouse {
        display: flex;
        flex-direction: row;
        justify-content: center;
        position: relative;
        width: 700px;
        /* background-color: orange; */
        position: relative;

        .book {
            width: 374px;
            position: absolute;
            //box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
            border-radius: 8px;
            overflow: hidden;
            border: 1px solid rgba(204, 204, 204, 0.6);
            cursor: pointer;
            
            img {
                width: 100%;
                height: 100%;
                border-radius: 8px;

            }
            transition: all 0.5s ease;
        }

        & .item-0 {
            width: 267px;
            height: 412px;
            z-index: 1;
            left: -30%;
            bottom: 60px;
            box-shadow: 0px 3.7px 5.6px 0px rgba(0, 0, 0, 0.1),
                        0px 9.4px 14px -2.7px rgba(0, 0, 0, 0.1);

            &::after {
                content: "";
                position: absolute;
                top: 0; left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
                background: rgba(0, 0, 0, 0.6); // 검정색 40% 투명도
            }
            
            
            
        }
        & .item-1 {
            width: 315px;
            height: 468px;
            z-index: 2;
            left: -15%;
            bottom: 40px;
            box-shadow: 0px 3.6px 5.3px 0px rgba(0, 0, 0, 0.1),
                        0px 8.9px 13.3px -2.7px rgba(0, 0, 0, 0.1);

            &::after {
                content: "";
                position: absolute;
                top: 0; left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
            }
            
        }
        
        & .item-2 {
            height: 548px;
            z-index: 3;
            left: 25%;
            bottom: 0;
            box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1),
                        0px 10px 15px -3px rgba(0, 0, 0, 0.1);
        }
        
        & .item-3 {
            width: 315px;
            height: 468px;
            z-index: 2;
            left: 70%;
            bottom: 40px;
            box-shadow: 0px 3.6px 5.3px 0px rgba(0, 0, 0, 0.1),
                        0px 8.9px 13.3px -2.7px rgba(0, 0, 0, 0.1);

            &::after {
                content: "";
                position: absolute;
                top: 0; left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
            }
            
        }
        & .item-4 {
            width: 267px;
            height: 412px;
            z-index: 1;
            left: 90%;
            bottom: 60px;
            box-shadow: 0px 3.7px 5.6px 0px rgba(0, 0, 0, 0.1),
                        0px 9.4px 14px -2.7px rgba(0, 0, 0, 0.1);


            &::after {
                content: "";
                position: absolute;
                top: 0; left: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
                background: rgba(0, 0, 0, 0.6); // 검정색 40% 투명도
            }
            
        }
    }

    .bookDot {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        width: 150px;
        margin-top : 70px;
        /* background-color: white; */

        .dot {
            border-radius: 50%;
            height: 14px;
            width: 14px;
            background-color: #c7bfbd;
        }

        & .now {
            background-color: #19cf7a;
        }
    }
`;


const NewTab = ({newBooks}: {newBooks: any}) => {
    const isMobile = useIsMobile();
    const navigate = useNavigate();

    const {
        bookList,
        currentIndex,
        dot,
        handleBookList,
        setCurrentIndex,
        setDot
    } = useNewBookList(newBooks);

    const handleBookDetail = (bookId: number) => {
        navigate(`/book/bookdetails/${bookId}`);
    };

    return (

<>
        { isMobile ?
            <NewBookMobile
                bookList={bookList}
                currentIndex={currentIndex}
                dot={dot}
                handleBookList={handleBookList}
                handleBookDetail={handleBookDetail}
            />
        :

                <>
                    <div css={newTabWrapCss}>
                        <div className="newTitle  z-10">
                            <h3 className="text-[36px] font-bold">
                                <span className="text-main">#NEW</span>
                            </h3>
                            <span className="text-[28px] text-black font-bold">신규 등록작품</span>
                        </div>

                        <div className="authorList  ">
                            <div id="author" className="mb-1 ">
                                {bookList[currentIndex] && (
                                    <span className="text-black text-[30px] font-medium">
                    {bookList[currentIndex].bookTitle.length > 15
                        ? bookList[currentIndex].bookTitle.slice(0, 15) + '...'
                        : bookList[currentIndex].bookTitle}
                </span>
                                )}
                            </div>
                            <div id="title" className="authorName">
                                {bookList[currentIndex] && (
                                    <span className="text-[24px] font-normal text-gray-800">
                    {bookList[currentIndex].authorName}
                </span>
                                )}
                            </div>
                        </div>

                        <div className="absolute  pointer-events-none  z-0 top-[-20px] left-[-200px]">
                            <BookBg2 className="w-full h-full" id="firstBg" />
                        </div>

                        <div className="absolute z-0 bottom-[-350px] right-[-280px] pointer-events-none">
                            <BookBg2 className="w-full h-full" id="seBg" />
                        </div>

                        <div id="bookList" className="flex justify-center items-center"  >

                            <div css={BookWrapper}>
                                <div css={BookListWrapper} className="relative">

                                    <div className="bookCarouse">
                                        {bookList.map((it : any, idx : number) => (
                                            it.id === 2 ? (
                                                <Link
                                                    key={idx}
                                                    to={`/book/bookdetails/${it.bookId}`}
                                                    className={`book item-${it.id} block`}
                                                >
                                                    {it.coverImage ?
                                                        <img src={`data:image/jpeg;base64,${it.coverImage}`} alt="책 이미지"/>
                                                        :
                                                        <img src={`${process.env.PUBLIC_URL}/img/book_4.jpg`} alt="책 이미지"/>
                                                    }
                                                </Link>
                                            ) : (
                                                <div
                                                    key={idx}
                                                    className={`book item-${it.id}`}
                                                    onClick={() => handleBookList(it.id)}
                                                >
                                                    {it.coverImage ?
                                                        <img src={`data:image/jpeg;base64,${it.coverImage}`} alt="책 이미지"/>
                                                        :
                                                        <img src={`${process.env.PUBLIC_URL}/img/book_4.jpg`} alt="책 이미지"/>
                                                    }
                                                </div>
                                            )
                                        ))}
                                    </div>
                                    <div className="bookDot">
                                        {bookList.map((it : any, idx: number) => (
                                            <div className={idx === dot ? "dot now" : "dot"}></div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                        </div>




                    </div>


                </>


        }

</>





    );
};

export default NewTab;
